import React, { useState } from 'react';

export const TestInput: React.FC = () => {
  const [value, setValue] = useState('');

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    console.log('Test input change event:', e);
    console.log('Test input target:', e?.target);
    console.log('Test input value:', e?.target?.value);
    
    if (e && e.target) {
      setValue(e.target.value);
    }
  };

  return (
    <div style={{ padding: '2rem', background: 'white', margin: '2rem' }}>
      <h3>Test Input Component</h3>
      <input
        type="text"
        value={value}
        onChange={handleChange}
        placeholder="Test typing here..."
        style={{ padding: '0.5rem', border: '1px solid #ccc' }}
      />
      <p>Current value: {value}</p>
    </div>
  );
};